<div class="customer-pricing-dashboard" *ngIf="data">
  <div class="state-message" *ngIf="loading">{{ cfg?.states?.loadingText || 'Loading...' }}</div>
  <div class="state-message state-message--error" *ngIf="!loading && error">{{ error }}</div>
  <div class="state-message" *ngIf="!loading && !error && !filteredPoints.length">
    {{ cfg?.states?.emptyText || 'No data available.' }}
  </div>

  <ng-container *ngIf="!loading && !error && filteredPoints.length">
    <section class="section section--chart">
      <div class="section-header">
        <h3>{{ cfg?.customerOverview?.title }}</h3>
        <div class="customer-legend" *ngIf="legendItems.length">
          <button
            type="button"
            class="customer-legend__item"
            *ngFor="let item of legendItems"
            [class.customer-legend__item--active]="selectedLegendCategory === item.label"
            [class.customer-legend__item--muted]="selectedLegendCategory && selectedLegendCategory !== item.label"
            (click)="toggleLegendCategory(item.label)">
            <span class="customer-legend__marker" [style.backgroundColor]="item.color"></span>
            <span>{{ item.label }}</span>
          </button>
        </div>
      </div>
      <div #chartHost class="customer-overview-chart" [style.height]="chartHeight"></div>
    </section>
  </ng-container>
</div>
